import React, { useEffect, useState } from "react";
import MainLayout from "../../../assets/Layout/MainLayout";
import { SlidesWrapper } from "./style/slide";
import Settings from "./components/Settings";
import PhonePreview from "./components/PhonePreview";
import DesktopPreview from "./components/DesktopPreview";
import Phone from "../../../assets/Images/icons/svgIcon/mobile-icon.svg";
import Desktop from "../../../assets/Images/icons/svgIcon/desktop-icon.svg";
import AddSlide from "./components/AddSlide";
import { toast } from "react-toastify";
import API from "../../../api/axios";
import { APP_URLS } from "../../../api/url";
import EditSlide from "./components/EditSlide";
import Sidebar from "../components/sidebar";
import { ASPECT_RATIOS } from "../../../config/constant";

const Slides2 = () => {

  const [tabview, setTabView] = useState("desktop");
  const [view, setView] = useState("setting");

  const [addtab, _addtab] = useState(false);
  const [slideID,_slideID] = useState('')

  const [images, setImages] = useState([]);
  const [duration,_duration] = useState(3)

  // Filters
  const [status, _status] = useState("");
  const [countryFilter, _countryFilter] = useState("");
  const [countValue, _countValue] = useState('');
  const [page, setPage] = useState(1);


  useEffect(() => {
    getSliders()
  }, [])
  

  const getSliders = () => {
    API.get(APP_URLS.SHOW_HOME_SLIDES)
      .then((res) => {
        const resp = res.data;
        if (resp.success === true) {
          let imageArr = []
          resp.data.items.forEach(item => {
            imageArr.push(item.media[0].original_url)
          });
          setImages(imageArr)
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(function (error) {
        const resp = error.response;
        let error_message = "";
        if (resp.data.data !== undefined && resp.data.data !== null) {
          {
            Object.keys(resp.data.data).map((error, index) => (error_message = resp.data.data[error][0]));
          }
        } else if (resp.data.data?.error !== undefined) {
          error_message = resp.data.data.error;
        } else if (resp.data?.error !== undefined) {
          error_message = resp.data.error;
        } else {
          error_message = resp.data.message;
        }
        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };


return (
  <>
    <SlidesWrapper>
      <div className="container">
        <div className="row mt-5">
          <div className="col-lg-2 px-0">
            <div className="view-menu">
              <div className="preview-icon">
              {view === "preview"?
                <>
                  <img src={Desktop} className={tabview === "desktop" ? "active-preview" : ""} onClick={() => setTabView("desktop")} />
                  <img src={Phone} className={tabview === "phone" ? "active-preview" : ""} onClick={() => setTabView("phone")} />
                </>:
                ''
              }
              </div>
              <Sidebar route='partner-slider'/>
            </div>
          </div>

          <div className="col-lg-10 px-0">
            <h1 className="">{addtab===false?"PARTNER SLIDER":slideID===""?"ADD SLIDES":"EDIT SLIDE"}</h1>
            {addtab===false?
            <span className="setting-preview-option ">
              <button className={(view !== "setting" ? "btn-inactive" : "") + " btn-link"} onClick={() => setView("setting")}>
                Settings
              </button>
              <button className={(view !== "preview" ? "btn-inactive" : "") + " btn-link"} onClick={() => setView("preview")}>
                Preview
              </button>
            </span>
            :""}
            {addtab===false?
            view === "setting" ? (
              <Settings 
                _addtab={_addtab} _slideID={_slideID} 
                status={status} _status={_status}
                page={page} setPage={setPage}
                countValue={countValue} _countValue={_countValue}
                countryFilter={countryFilter} _countryFilter={_countryFilter}
              />
            ) : tabview === "desktop" ? (
              <DesktopPreview images={images} duration={duration}/>
            ) : (
              <PhonePreview images={images} duration={duration}/>
            ):
            slideID===""?
            <AddSlide aspectRatio = {ASPECT_RATIOS.PARTNER} _addtab={_addtab}/>:
            <EditSlide aspectRatio = {ASPECT_RATIOS.PARTNER} _addtab={_addtab} slideID={slideID} _slideID={_slideID}/>
            }
          </div>
        </div>
      </div>
    </SlidesWrapper>
  </>
);
};

export default Slides2;
